import React, { useState } from 'react';
import RideAppIcon from './RideAppIcon';
import RidePortal from './RidePortal';

const iconFor = (id) => (id === 'home' ? 'home' : id === 'work' ? 'work' : 'bookmark');

const RideSavedPlacesSheet = ({ places, onAdd, onClose, onDelete, onRename, onSelect }) => {
  const [editing, setEditing] = useState(null);
  const [adding, setAdding] = useState(false);
  const [label, setLabel] = useState('');
  const beginRename = (place) => { setAdding(false); setEditing(place); setLabel(place.label); };
  const saveLabel = () => {
    const next = label.trim();
    if (!next) return;
    if (editing) onRename(editing.id, next);
    else if (adding) onAdd(next);
    setEditing(null);
    setAdding(false);
    setLabel('');
  };

  return (
    <RidePortal>
      <div className="ride-saved-sheet-backdrop" role="presentation" onMouseDown={onClose}>
        <section className="ride-saved-sheet" role="dialog" aria-modal="true" aria-label="Địa điểm đã lưu" onMouseDown={(event) => event.stopPropagation()}>
          <div className="ride-saved-sheet__head"><div><span>XE GHÉP</span><h3>Địa điểm đã lưu</h3></div><button type="button" aria-label="Đóng" onClick={onClose}><RideAppIcon name="close" /></button></div>
          {places.length === 0 ? <div className="ride-saved-sheet__empty"><RideAppIcon name="bookmark" /><b>Bạn chưa lưu địa điểm nào</b><small>Thêm địa điểm để chọn nhanh ở lần sau.</small></div> : <div className="ride-saved-sheet__list">{places.map((place) => <article key={place.id}>
            <button type="button" className="ride-saved-sheet__place" onClick={() => onSelect(place)}><RideAppIcon name={iconFor(place.id)} /><span><b>{place.label}</b><small>{place.point.address}</small></span></button>
            <button type="button" aria-label={`Đổi tên ${place.label}`} onClick={() => beginRename(place)}><RideAppIcon name="edit" /></button>
            <button type="button" className="danger" aria-label={`Xoá ${place.label}`} onClick={() => onDelete(place.id)}><RideAppIcon name="trash" /></button>
          </article>)}</div>}
          {(editing || adding) && <div className="ride-saved-sheet__rename"><label>{editing ? 'Đổi tên địa điểm' : 'Tên địa điểm'}<input autoFocus value={label} maxLength={80} placeholder="Ví dụ: Nhà bố mẹ, Phòng gym" onChange={(event) => setLabel(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') saveLabel(); }} /></label><div><button type="button" onClick={() => { setEditing(null); setAdding(false); setLabel(''); }}>Huỷ</button><button type="button" className="primary" onClick={saveLabel}>{editing ? 'Lưu' : 'Tiếp tục'}</button></div></div>}
          <button type="button" className="ride-saved-sheet__add" onClick={() => { setEditing(null); setAdding(true); setLabel(''); }}><RideAppIcon name="add" /> Thêm địa điểm</button>
        </section>
      </div>
    </RidePortal>
  );
};

export default RideSavedPlacesSheet;
